<template>
    <div class="map" ref="map" id="map">
        <!-- <a class="mapApp" :href="href+'amap://navi?sourceApplication=appname&amp;poiname=重庆北碚区三溪口蔡家组团蔡家工谷34栋厂房&amp;lat=29.752541&amp;lon=106.466049&amp;dev=1&amp;style=2'">导航去公司</a> -->
    </div>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader';
export default {

    data(){
        return {
            map : null,
            flag : true,
            href : ''
        }
    },    

    created(){
        this.flag = this.isAndroid()
        if(this.flag){
            this.href = 'android'
        }else{
            this.href = 'ios'
        }
        AMapLoader.load({
            "key": "769bb1efa13b134da64e5ad361e0e936", 
            "version": "2.0",   
        }).then(AMap=>{
            let map = new AMap.Map('map',{
                zoom : 20,
                resizeEnable: true,
                center : [106.466049,29.752541]
            });
            this.map = map
            this.setMarker(AMap);
            this.setText(AMap)
        })
    },

    methods :{
        setMarker(AMap){
            var marker = new AMap.Marker({
                position: new AMap.LngLat(106.466049, 29.752541),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
                title: '北京'
            });
            this.map.add(marker);
        },
        setText(AMap){
            let text = new AMap.Text({
                text : '重庆北碚区三溪口蔡家组团蔡家工谷34栋厂房',
                // position: [106.466049,29.752541],
                // cursor:'pointer',
                // anchor:'center',
                draggable:true,
                 style:{
                    'width': '300px',
                    'color': '#0095ff',
                    'font-size': '15px',
                    'box-shadow': '0 2px 6px 0 rgba(114, 124, 245, .5)',
                    'word-break':'break-all',
                    'white-space': 'pre-wrap'
                 }
            })
            text.setMap(this.map)
        },
        isAndroid() {
            var u = navigator.userAgent;
            if (u.indexOf("Android") > -1 || u.indexOf("Linux") > -1) {
                return true;
            }
            return false;
        },
    }

}
</script>

<style scoped lang='scss'>

    .map{
        width: 100%;
        height: 45.213vw;
    }
    .mapApp{
        position: absolute;
        bottom: 0;
        z-index: 999;
        right: 0;
        padding: 1.33vw 2.66vw;
        background-color: rgba(202, 202, 202, 0.49);
    }

</style>